class BlogNavigation {
    constructor() {
        this.sectionLinks = document.querySelectorAll('.section-link');
        this.blogSections = document.querySelectorAll('.blogs-wrap > div');
        this.navContainer = document.querySelector('.blogs-navigation');
        this.allBlogsContainer = document.querySelector('.articles-container');
        this.paginationContainer = document.querySelector('.pagination-container');

        this.init();
    }

    init() {
        this.sectionLinks.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                this.sectionLinks.forEach(link => link.classList.remove('active'));
                link.classList.add('active');

                const blogTag = link.getAttribute('data-blog-tag');
                const sectionId = link.getAttribute('data-section-id');

                if (sectionId === "all_blogs") {
                    this.showAllArticles();
                } else if (blogTag) {
                    this.showArticlesByTag(blogTag);
                } else if (this.sectionLinks.length > 0) {
                    const firstTag = this.sectionLinks[0].getAttribute('data-blog-tag');
                    this.showArticlesByTag(firstTag);
                }
            });
        });
    }

    showArticlesByTag(tag) {
        this.blogSections.forEach(section => (section.style.display = 'none'));
        this.paginationContainer.style.display = 'none';

        const newUrl = window.location.origin + window.location.pathname;
        window.history.pushState(null, null, newUrl);

        document.querySelectorAll(`.blogs-wrap [data-blog-tag="${tag}"]`).forEach(section => {
            section.style.display = 'grid';
            section.classList.add('fade-in');
        });

        const matchingLink = Array.from(this.sectionLinks).find(
            link => link.getAttribute('data-blog-tag') === tag
        );

        if (matchingLink) {
            matchingLink.classList.add('active');
        }

        const linkPosition =
            matchingLink.getBoundingClientRect().left - this.navContainer.getBoundingClientRect().left;
        this.navContainer.scrollTo({
            left: this.navContainer.scrollLeft + linkPosition - 20,
            behavior: 'smooth',
        });
    }

    showAllArticles() {
        this.blogSections.forEach(section => (section.style.display = 'none'));
        this.paginationContainer.style.display = 'flex';
        this.allBlogsContainer.style.display = 'grid';

        const allBlogsLink = Array.from(this.sectionLinks).find(
            link => link.getAttribute('data-section-id') === "all_blogs"
        );

        if (allBlogsLink) {
            allBlogsLink.classList.add('active');
        }

        const linkPosition =
            allBlogsLink.getBoundingClientRect().left - this.navContainer.getBoundingClientRect().left;
        this.navContainer.scrollTo({
            left: this.navContainer.scrollLeft + linkPosition - 20,
            behavior: 'smooth',
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new BlogNavigation();
});
